import React from 'react';

import { SongStatus } from '@/component';
import { generalHelpers } from '@/helpers';
import { get } from 'lodash';

interface Column {
  field: string;
  headerName: string;
  className?: string;
  isCheckbox?: boolean;
  isSort?: boolean;
  renderCell?: (row?: object) => React.ReactNode;
}

export const column: Array<Column> = [
  {
    field: 'amount',
    headerName: 'Amount',
  },
  {
    field: 'created_at',
    headerName: 'Date Initiated',
    renderCell: (row?: object) => {
      if (
        row &&
        'created_at' in row &&
        'updated_at' in row &&
        'status' in row &&
        'account_number' in row
      ) {
        const typedRow = row as {
          created_at: string;
          updated_at: string;
          status: string;
          account_number: string;
        };
        return <p>{generalHelpers.convertDate(new Date(typedRow.created_at))}</p>;
      }
      return null;
    },
  },
  {
    field: 'updated_at',
    headerName: 'Date Finished',
    renderCell: (row?: object) => {
      if (
        row &&
        'created_at' in row &&
        'updated_at' in row &&
        'status' in row &&
        'account_number' in row
      ) {
        const typedRow = row as {
          created_at: string;
          updated_at: string;
          status: string;
          account_number: string;
        };
        return <p>{generalHelpers.convertDate(new Date(typedRow.updated_at))}</p>;
      }
      return null;
    },
  },
  {
    field: 'status',
    headerName: 'Status',
    // eslint-disable-next-line react/react-in-jsx-scope

    renderCell: (row?: object) => {
      if (
        row &&
        'created_at' in row &&
        'updated_at' in row &&
        'status' in row &&
        'account_number' in row
      ) {
        const typedRow = row as {
          created_at: string;
          updated_at: string;
          status: string;
          account_number: string;
        };
        return <SongStatus status={get(typedRow, 'status', '')} />;
      }
      return null;
    },
  },
  {
    field: 'account_number',
    headerName: 'Account Number',
  },
];
